import type { Components } from '@/api/generated/api';
import { getGradeScaleLevelName } from '@/utils/performance.utils';
import type { TTranslate } from '@/interfaces';
import { getSchoolGradeName as resolveSchoolGradeName } from 'common/utils/school.grade.utils';

export const getSchoolGradeName = (
  value: number,
  levels: readonly Components.Schemas.GradeLevelDto[],
  t: TTranslate,
): string => resolveSchoolGradeName(value, levels, (level) => getGradeScaleLevelName(level, t));
